/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
var isZeroValueString = function (v) {
  return /^0[^.\s]+$/.test(v);
};
export { isZeroValueString };